/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function() {
  // Add custom code below this line

  if (window.location.pathname.indexOf('/products') > -1) {
    const tryInjectYotpoAvgScore = () => {
      const target = document.querySelector('.product__price-and-rating .yotpo-bottomline');
      const avgScore = document.querySelector('.main-widget .avg-score');

      if (!target || !avgScore) return false;
      if (target.querySelector('.avg-score')) return true;

      const avgStoreCopy = avgScore.cloneNode(true);
      target.insertAdjacentElement('afterbegin', avgStoreCopy);
      return true;
    };

    const startYotpoObserver = () => {
      if (tryInjectYotpoAvgScore()) return;

      const observeRoot = document.querySelector('.product-single__wrapper') || document.body;
      const observer = new MutationObserver(() => {
        if (tryInjectYotpoAvgScore()) observer.disconnect();
      });

      observer.observe(observeRoot, {
        childList: true,
        subtree: true,
        attributes: false,
        characterData: false,
      });

      // Safety stop: do not keep observing forever on PDP.
      setTimeout(() => observer.disconnect(), 10000);
    };

    if ('requestIdleCallback' in window) {
      requestIdleCallback(startYotpoObserver, { timeout: 2000 });
    } else {
      setTimeout(startYotpoObserver, 1200);
    }
  }

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.

  document.addEventListener("click", (evt) => {
    handleKlaviyoFormTriggers(evt);
    handleGovxClickTracking(evt);
  })

  function handleKlaviyoFormTriggers(evt) {
    const $el = evt.target.closest(`a[href*="#klaviyo-"]`);

    if (!$el) return;

    evt.preventDefault();

    const formId = $el.getAttribute("href").replace("#klaviyo-", "");
    if (window.klaviyo && typeof window.klaviyo.openForm === "function") {
      window.klaviyo.openForm(formId);
      return;
    }
    window.__deferredKlaviyoFormOpens = window.__deferredKlaviyoFormOpens || [];
    window.__deferredKlaviyoFormOpens.push(formId);
  }

  function handleGovxClickTracking(evt) {
    const link = evt.target.closest('a[data-govx="true"]');
    if (!link || typeof gtag !== 'function') return;

    gtag('event', 'govx_click', {
      page_type: getPageType(),
      link_location: link.dataset.govxName || 'unknown',
      link_text: (link.textContent || '').replace(/\s+/g, ' ').trim(),
      section_id: link.dataset.govxSection || '',
      destination_url: link.href,
      page_path: window.location.pathname,
      page_title: document.title
    });
  }

  function getPageType() {
    const bodyClass = document.body.className || '';

    if (bodyClass.indexOf('template-product') > -1) return 'product';
    if (bodyClass.indexOf('template-index') > -1) return 'home';
    if (bodyClass.indexOf('template-page') > -1) return 'page';
    if (bodyClass.indexOf('template-collection') > -1) return 'collection';

    return 'other';
  }

  window.addEventListener("load", () => {
    const $prodPrice = document.querySelector(".product__price-and-rating > .product__price > .product__price--regular");
    const $prodComparePrice = document.querySelector(".product__price-and-rating > .product__price > .product__price--compare");

    if ($prodPrice) {
      let $prodPriceOriginal = convertValue($prodPrice.innerText);
      let $prodComparePriceOriginal = $prodComparePrice ? convertValue($prodComparePrice.innerText) : 0;

      // Check if the subscription panel is visible
      if (document.querySelectorAll(".yotpo-plans-and-policy-wrapper").length === 0) {
        const $qtyInput = document.querySelector('.quantity-selector [name="quantity"]');
        const $setQtyBtns = document.querySelectorAll(".product-price-chart [data-set-qty]");

        const $prdSelBtns = document.querySelectorAll(".product__selectors .radio__button .radio__input");

        if ($prdSelBtns.length) {
          $prdSelBtns.forEach(($btn) => {
            const $variantPriceOriginal = convertValue($btn.dataset.price);

            $btn.addEventListener("click", () => {
              $prodPriceOriginal = $variantPriceOriginal;
              $qtyInput.value = 1;

              if ($setQtyBtns.length) {
                $setQtyBtns.forEach(($btn) => {
                  const unitPrice = ($prodPriceOriginal - (($prodPriceOriginal * convertValue($btn.dataset.discount)) / 100)).toFixed(2).split('.');

                  $btn.querySelector("span > b").innerHTML = `$${unitPrice[0]}<sup>.${unitPrice[1]}</sup>`
                  $btn.classList.remove("is-active");
                });
              }
            });

            if ($btn.checked) $btn.click();
          });
        }

        const $qtyBtns = document.querySelectorAll(".quantity-selector .quantity__btn");

        if ($qtyBtns.length) {
          let maxQty = 0;

          function updateActiveQtyBtn() {
            const qty = +$qtyInput.value;

            $setQtyBtns.forEach(($btn) => {
              const btnQty = +$btn.getAttribute("data-set-qty");
              const isActive = btnQty === (qty > maxQty ? maxQty : qty);
              $btn.classList.toggle("is-active", isActive);
            });

            let newPrice = "";
            let newComparePrice = "";

            if (qty == 1) { 
              newPrice = "$" + $prodPriceOriginal.toFixed(2);
              if($prodComparePrice) newComparePrice = "$" + $prodComparePriceOriginal.toFixed(2);
            }
            else {
              let unitPrice = "";

              if ($setQtyBtns.length) unitPrice = document.querySelector(".product-price-chart [data-set-qty].is-active span > b").innerText;
              else unitPrice = "$" + $prodPriceOriginal.toFixed(2);

              newPrice = `<span class="product__price--unit">${qty} x ${unitPrice}</span><br />${(convertValue(unitPrice) * qty).toLocaleString('en-US', { style: 'currency', currency: 'USD' })}`;
              if($prodComparePrice) newComparePrice = `${( $prodComparePriceOriginal * qty).toLocaleString('en-US', { style: 'currency', currency: 'USD' })}`;
            }

            $prodPrice.innerHTML = newPrice;
            if ($prodComparePrice) $prodComparePrice.innerHTML = newComparePrice;
          }
          updateActiveQtyBtn();

          $qtyInput.addEventListener("change", updateActiveQtyBtn);

          $setQtyBtns.forEach(($btn) => {
            const btnQty = +$btn.getAttribute("data-set-qty");

            if (btnQty > maxQty) maxQty = btnQty;

            $btn.addEventListener("click", () => {
              let newQty = 1;

              if (!$btn.classList.contains("is-active")) {
                newQty = +$btn.getAttribute("data-set-qty");
                newQty = !isNaN(newQty) ? newQty : 1;
              }

              $qtyInput.value = newQty;
              setTimeout(() => $qtyInput.dispatchEvent(new Event("change")), 500);
            });
          });

          $qtyBtns.forEach(($btn) => {
            $btn.addEventListener("click", () => setTimeout(() => $qtyInput.dispatchEvent(new Event("change")), 500));
          });
        }
      }

      function convertValue(value) {
        let newValue = value.replace(/[^0-9.-]+/g, "");
        return parseFloat(newValue);
      }
    }
  });
})();

class ProductDescription extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    const $items = Array.from(this.children);
    this.setItemAttributes($items);
    
    const type = this.getAttribute('data-type');
    if (type === 'accordion') {
      this.initAccordion($items);
    }
  }

  setItemAttributes($items) {
    let currentGroup = 0;
    $items.forEach(($item) => {
      const text = $item.textContent;
      const isGroupHeader = text.endsWith(':');
      if (isGroupHeader) {
        if ($item.innerText.startsWith('Product Section ')) {
          $item.innerText = $item.innerText.replace('Product Section ', '');
        }

        if ($item.innerText.startsWith('Bullets')) {
          $item.innerText = $item.innerText.replace('Bullets', 'Benefits');
        }

        $item.setAttribute('data-heading', '');
        currentGroup++;
      }

      $item.setAttribute('data-order', currentGroup);
    });
  }

  initAccordion($items) {
    const itemGroups = [];
    $items.forEach(($item) => {
      const order = $item.getAttribute('data-order');
      if (!itemGroups[order]) {
        itemGroups[order] = [];
      }
      itemGroups[order].push($item);
    });

    this.innerHTML = '';
    itemGroups.forEach((group) => {
      const $group = document.createElement('div');
      $group.classList.add('product-description__group');

      const $groupContentWrapper = document.createElement('div');
      $groupContentWrapper.classList.add('product-description__group-content-wrapper');
      $group.appendChild($groupContentWrapper);

      const $groupContent = document.createElement('div');
      $groupContent.classList.add('product-description__group-content');
      $groupContentWrapper.appendChild($groupContent);

      group.forEach(($item, index) => {
        if (index === 0) {
          $item.innerText = $item.innerText.replace(':', '');

          const slug = $item.innerText.toLowerCase().replace(/ /g, '-');
          $group.setAttribute('data-slug', slug);

          $group.prepend($item);
        } else {
          $groupContent.appendChild($item);
        }
      });

      this.appendChild($group);
    });

    const $groups = Array.from(this.querySelectorAll('.product-description__group'));

    function activateAccordion($groups, groupIndex) {
      $groups.forEach(($group, index) => {
        if (index === groupIndex) $group.classList.toggle('active');
        else $group.classList.toggle('active', false);
      });
    }

    $groups.forEach(($group, groupIndex) => {
      const $heading = $group.querySelector('[data-heading]');
      $heading.addEventListener('click', () => {
        activateAccordion($groups, groupIndex);
      });
    });

    activateAccordion($groups, 0);
  }
}
customElements.define('product-description', ProductDescription);

class YotpoRewardsHTML extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.handleFAQ();
  }

  handleFAQ() {
    const $faqItemTogglers = this.querySelectorAll(".yotpo-rewards__faq-item-toggler");
    $faqItemTogglers.forEach(($faqItemToggler) => {
      $faqItemToggler.addEventListener("click", () => {
        $faqItemToggler.classList.toggle("active");
      });
    });
  }
}
customElements.define('yotpo-rewards', YotpoRewardsHTML);


document.addEventListener('DOMContentLoaded', () => {
  const formContainer = document.querySelector('.form-container');

  const observer = new MutationObserver((mutationsList, observer) => {
  const form = document.querySelector('form-embed');

if (form && form.shadowRoot) {
  observer.disconnect();
  const shadow = form.shadowRoot;

  const sheet = new CSSStyleSheet();
  sheet.insertRule(`
    input, textarea {
      border-radius: 0px !important;
      border: none !important;
      font-size: 19px !important;
    }
     button[aria-expanded], ._formSubmitButton_1nihh_77 {
    font-size:49px !important;
    font-weight: bold !important;
    background-color:black !important;
    }
  `);

  shadow.adoptedStyleSheets.push(sheet);
  formContainer.classList.add('loaded');
}
});

observer.observe(document.body, { childList: true, subtree: true });
});
